import { LEAD_EVENT_STAGES } from '../../constants/leadEventStages';

export function mapTrainingCertifiedPayload() {
  return {
    stage: LEAD_EVENT_STAGES.TRAINING_CERTIFIED,
    content: { approved: true },
  };
}
